import { render, staticRenderFns } from "./AddForm.vue?vue&type=template&id=686bbeb1"
import script from "./AddForm.vue?vue&type=script&lang=js"
export * from "./AddForm.vue?vue&type=script&lang=js"
import style0 from "./AddForm.vue?vue&type=style&index=0&id=686bbeb1&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('686bbeb1')) {
      api.createRecord('686bbeb1', component.options)
    } else {
      api.reload('686bbeb1', component.options)
    }
    module.hot.accept("./AddForm.vue?vue&type=template&id=686bbeb1", function () {
      api.rerender('686bbeb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/billing/Transactions/components/AddForm.vue"
export default component.exports